import * as React from 'react';

import { formatTime } from '../../helpers/date';
import { LiveChatAgentStateChangeMessageContentType } from '../../store';

interface LiveChatAgentStateChangeMessageProps {
	timestamp: number;
	content: LiveChatAgentStateChangeMessageContentType;
}

export const LiveChatAgentStateChangeMessage: React.FC<LiveChatAgentStateChangeMessageProps> = ({
	timestamp,
	content,
}) => {
	const firstName = content.name.split(' ')[0];

	return (
		<div className="flex items-center justify-center mx-2 mb-2 text-center">
			{content.state === 'active' ? (
				<div
					data-testid="live-chat-agent-connected"
					className="text-body-sm bg-gray-30 px-3 py-1 rounded-md"
				>
					<div className="text-xs">{formatTime(timestamp)}</div>
					You&apos;re now chatting to&nbsp;
					<strong>{firstName}</strong>
				</div>
			) : (
				<div
					data-testid="live-chat-agent-disconnected"
					className="text-body-sm bg-gray-30 px-3 py-1 rounded-md"
				>
					<div className="text-xs">{formatTime(timestamp)}</div>
					<strong>{firstName}&nbsp;</strong>has left the conversation
				</div>
			)}
		</div>
	);
};

export default LiveChatAgentStateChangeMessage;
